require('readmore-js');

export default (function () {
  $('.latest-testimonials .testimonials-item .testimonials-card__text').readmore({
    speed: 75,
    collapsedHeight: 80,
    lessLink: '<a href="#">Read less</a>',
    moreLink: '<a href="#">Read more</a>',
    heightMargin: 2,
    embedCSS: false
  });
  $('.testimonials-card__more').click(function () {
    var $parent = $(this).closest('.testimonials-card');
    var $more = $(this).data('more');
    var $less = $(this).data('less');

    if ($parent.hasClass('active')) {
      $parent.removeClass('active');
      $(this).text($more);
    } else {
      $parent.addClass('active');
      $(this).text($less);
    }
  });
});